module.exports = __webpack_public_path__ + "img/pilosangeles.52949c3a.png";